// extracted by mini-css-extract-plugin
export default {"activity":"EventActivity_activity__H4ERa","activity-heading":"EventActivity_activity-heading__mBIdf"};